import React from 'react'
import '../../App.css'
import './Vision.css'
import BackgroundSection from '../BackgroundSection'
import ContainerSection from '../ContainerSection'
import { Title } from '../Title'
import AgriDev1 from '../../images/agri-dev1.jpg'
import AgriDev2 from '../../images/agri-dev2.jpg'
import Farmers1 from '../../images/farmers1.jpg'
import Farmers2 from '../../images/farmers2.jpg'
import Farmers3 from '../../images/farmers3.jpg'
import Hunger from '../../images/hunger.jpg'
import FoodPrices from '../../images/foodprices.jpg'

export const Vision = () => {
  return (
    <>
      <BackgroundSection
        className='background'
        backgroundStyle='background--second'
      >
        Our Vision
      </BackgroundSection>

      <ContainerSection
        className='container'
        containerStyle='container--conone'
      >
        <Title
          className='title'
          titleStyle='title--trans'
          titleSize='title--large'
        >
          Agriculture's Development
        </Title>
        <div className='ag-dev-container'>
          <div className='ag-dev'>
            <img
              className='ag-dev1'
              src={AgriDev1}
              alt='agriculture devlopment'
            />
            <img
              className='ag-dev2'
              src={AgriDev2}
              alt='agriculture devlopment'
            />
          </div>
          <div className='text-container'>
            <p className='text'>
              Agriculture is critical to the future of sustainable development.
              Globally the entire sector is being challenged to produce
              approxiately 70% more food to feed 9 billion people by 2050. It
              has been acknowledged that most of this increase will need to come
              from greater land and water productivity as well as expansion of
              arable and irrigated areas. However, currently, agriculture
              consumes 70% of global freshwater, and emits about a quarter of
              all global greenhouse gases. Some of the current farming practices
              have negative consequences on water quality, and they impact
              biodiversity through land clearing and habitat fragmentation.
              Commodities production has been identified as one of the key
              causes of deforestation worldwide. Therefore the central question
              on the future of global sustainable development is how this vast
              increase in food and agriculture commodities supply can be
              achieved in a sustainable way.
            </p>
          </div>
        </div>
      </ContainerSection>

      <ContainerSection
        className='container'
        containerStyle='container--contwo'
      >
        <Title
          className='title'
          titleStyle='title--trans'
          titleSize='title--large'
        >
          The Critical Role of Smallholder Farmers
        </Title>
        <div className='farm-container'>
          <div className='farm'>
            <div className='farm12-container'>
              <img className='farm1' src={Farmers1} alt='farmers' />
              <img className='farm2' src={Farmers2} alt='farmers' />
            </div>
            <div className='farm3-container'>
              <img className='farm3' src={Farmers3} alt='farmers' />
              <div className='text-container'>
                <p className='text'>
                  More than 500 million smallholder farms worldwide play a
                  significant role in food production and the geneitc diversity
                  of the food supply. Until now, it has been difficult to get
                  information to or from smallholder farmers, compounding basic
                  infrastructural problems such as acess to inputs, markets,
                  financing, and training. The spread of mobile technology,
                  remote sensing data, and distributed computing and storage
                  capabilities are opening new opportunities to integrate
                  smallholder farmers into the broader agri-food system. The
                  scale of these changes holds out the potential for another
                  agricultural revolution.
                </p>
              </div>
            </div>
          </div>
          <div className='farm4-container'>
            <img className='farm4' src={Hunger} alt='hunger' />
          </div>
          <ol className='text-list'>
            <li className='text'>
              food price volatility amplifies social unrest,
            </li>
            <li className='text'>
              extreme weather events displace millions of people,
            </li>
            <li className='text'>
              climate change amplifies instability, inequality and poverty
            </li>
          </ol>
        </div>
      </ContainerSection>

      <ContainerSection
        className='container'
        containerStyle='container--conone'
      >
        <Title
          className='title'
          titleStyle='title--trans'
          titleSize='title--large'
        >
          10 Facts Behind Food Prices
        </Title>
        <div className='foodprices-container'>
          <img className='foodprices' src={FoodPrices} alt='food prices' />
        </div>
      </ContainerSection>
    </>
  )
}
